import FormUsersCreationContainer from './FormUsersCreation.container';
import FormGuestUsersInvitationContainer from './FormGuestUsersInvitation.container';

export const FormGuestUsersInvitation = FormGuestUsersInvitationContainer;

export default FormUsersCreationContainer;
